import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Local storage key for emulator preference
const EMULATOR_PREF_KEY = 'useFirebaseEmulator';

// Firebase production configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Check if emulator preference is stored in localStorage
// Only use this in development mode for safety
const getEmulatorPreference = () => {
    if (process.env.NODE_ENV !== 'development') return false;
    
    try {
        const pref = localStorage.getItem(EMULATOR_PREF_KEY);
        return pref === 'true';
    } catch (error) {
        console.error('Error accessing localStorage:', error);
        return false;
    }
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Determine if emulators should be used
let useEmulators = process.env.NODE_ENV === 'development' && 
                 (process.env.REACT_APP_USE_EMULATOR === 'true' || getEmulatorPreference());

// Function to connect to emulators
const connectToEmulators = () => {
    console.log('Connecting to Firebase Emulators');
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectDatabaseEmulator(database, 'localhost', 9000);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectStorageEmulator(storage, 'localhost', 9199);
};

// Connect to emulators if needed
if (useEmulators) {
    connectToEmulators();
}

// Function to toggle emulator mode (only works in development)
export const toggleEmulatorMode = () => {
    if (process.env.NODE_ENV !== 'development') {
        console.warn('Emulator toggle is only available in development mode');
        return false;
    }
    
    // Toggle the current state
    useEmulators = !useEmulators;
    
    // Save preference to localStorage
    try {
        localStorage.setItem(EMULATOR_PREF_KEY, useEmulators.toString());
    } catch (error) {
        console.error('Error saving to localStorage:', error);
    }
    
    // Alert user about the change and need to reload
    alert(`Firebase ${useEmulators ? 'Emulator' : 'Production'} mode enabled. The page will now reload.`);
    
    // Reload the page to apply changes
    window.location.reload();
    
    return useEmulators;
};

// Check if currently using emulators
export const isEmulatorMode = () => useEmulators; 